import React from 'react';
import PublicationSection from '../Components/PublicationSection';
import Snow from '../Components/Snow'

const Publication: React.FC = () => {
  return (
    <div>
            {/* <Snow/> */}
      <PublicationSection/>
    </div>
  );
};

export default Publication;